// store
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useGeoRecordDeleteRequestService = () => {
    // hooks
    const axios = useAxios();
    const store = useStore();
    const { apiUrl } = useStore().state;

    // methods
    const getGeoRecDelCourseAcc = async (organizationId: number, courseId: number): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/geo-record/delete-request/course-members/${organizationId}/${courseId}`,
        );
        return res.data;
    };

    const getDeleteRequestApprovedCourseMembers = async (organizationId: number, courseId: number): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/geo-record/delete-request/approved-course-members/${organizationId}/${courseId}`,
        );
        return res.data;
    };

    const getSelfPendingDeleteRequestList = async (): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/geo-record/delete-request/list`,
        );
        return res.data;
    };

    const updateDeleteRequestApprovedCourseMembers = async (organizationId: number, courseId: number, approvedMemberIds: number[]) => {
        const res = await axios.put(
            `${apiUrl}/geo-record/delete-request/approved-course-members/${organizationId}/${courseId}`,
            approvedMemberIds
        );
        return res.data;
    };


    return {
        getGeoRecDelCourseAcc,
        getDeleteRequestApprovedCourseMembers,
        updateDeleteRequestApprovedCourseMembers,
        getSelfPendingDeleteRequestList,
    };
};
